import { platformStoreGet } from '../../../shared/helpers'
import configuration from '../configuration'
import { profileServiceDelete, profileServiceGet } from '../lib/utils'

const uidKey = 'uID-ga'
const deviceKey = 'deviceId-ga'

export function deActivateDevice() {
  const deactivateUrl = configuration.apiUrls.deviceDeactivation
    .replace('[UID]', platformStoreGet(uidKey) || '')
    .replace('[deviceId]', platformStoreGet(deviceKey) || '')

  return profileServiceDelete(deactivateUrl)
}

export function getActivationStatus() {
  const url = configuration.apiUrls.deviceActivationStatus.replace(
    '[deviceId]',
    platformStoreGet(deviceKey) || ''
  )

  return profileServiceGet(url)
}
